<template>
    <div id="main-footer">
        <section class="kpa-container">
            <div class="sem-container">
                <b>{{staticLanguageMessages.front_label_safety_environmental_manager}}</b>
                <div class="sem-block sem-border">
                    <strong>Devin Beck, U.S. & AUS</strong>
                    <ul>
                        <li>T: (909) 510-4272</li>
                        <li>|</li>
                        <li>C: (562) 266-6571</li>
                        <li>|</li>
                        <li><a href="mailto:dbeck@vvgtruck.com">E: dbeck@vvgtruck.com</a></li>
                    </ul>
                </div>
                <!-- <div class="sem-block">
                    <strong>Chase Farmer, CSP (EHS Manager)</strong>
                    <ul>
                        <li>T: (623) 907-6442</li>
                        <li>|</li>
                        <li>C: (806) 557-8858</li>
                        <li>|</li>
                        <li><a href="mailto:cfarmer@vvgtruck.com">E: cfarmer@vvgtruck.com</a></li>
                    </ul>
                </div> -->
                <div class="sem-block">
                    <strong>Jim Nyman, Mid-West</strong>
                    <ul>
                        <li>T: (623) 907-6442</li>
                        <li>|</li>
                        <li>C: (480) 689-2561</li>
                        <li>|</li>
                        <li><a href="mailto:jnyman@vvgtruck.com">E: jnyman@vvgtruck.com</a></li>
                    </ul>
                </div>
                <div class="sem-block sem-border">
                   <!--  <strong>Mike Ensminger, EHS Coordinator</strong> -->
                    <strong>Mike Ensminger, South East</strong>
                    <ul>
                        <li>T: (615) 369-2857</li>
                        <li>|</li>
                        <li>C: (615) 785-0677</li>
                        <li>|</li>
                        <li><a href="mailto:mensminger@vvgtruck.com">E: mensminger@vvgtruck.com</a></li>
                    </ul>
                </div>
                <div class="sem-block">
                    <!-- <strong>Ramiro Guerrero, EHS Manager</strong> -->
                    <strong>Ramiro Guerrero, West</strong>
                    <ul>
                        <!-- <li>T: (623) 907-6442</li>
                        <li>|</li> -->
                        <li>C: (951) 427-4908</li>
                        <li>|</li>
                        <li><a href="mailto:rguerrero@vvgtruck.com">E: rguerrero@vvgtruck.com</a></li>
                    </ul>
                </div>
                <div class="sem-block">
                    <strong>Joel Redmond, East</strong>
                    <ul>
                        <li>C: (601) 590-5118</li>
                        <li>|</li>
                        <li><a href="mailto:mensminger@vvgtruck.com">E: jredmond@vvgtruck.com</a></li>
                    </ul>
                </div>
            </div>
            <!-- <img src="/static/images/kpa-logo.png" alt="KPA"> -->
        </section>
        <section class="copyright">@ {{currentYear}}<!--2019-->   {{staticLanguageMessages.front_label_footer_msg}}</section>
        <cookie-law>
            <div slot="message">
                {{staticLanguageMessages.front_label_cookie}} <a class="policyLink" href="https://www.velocityvehiclegroup.com/privacy" target="_blank">{{staticLanguageMessages.front_label_learn_more}}</a>.
            </div>
        </cookie-law>
    </div>
</template>
<script>
    import index from "../../router";
    import EventBus from "../event-bus";
    import Vue from "vue";
    import SessioMixin from '../../mixins/sessionmixin';
    import CookieLaw from 'vue-cookie-law';
    import labelENMessages from '../../languages/label_en';
    import labelESMessages from '../../languages/label_es';
    import moment from 'moment';
    var self;
    export default {
        components: {
            CookieLaw,
        },
        /*import * as mykey from '/static/js/jquery.rotateSlider.js',*/
        name: "HomeFooter",
        mixins: [SessioMixin],
        data() {
            return {
                englishStaticLabelMessages: labelENMessages,
                spanishStaticLabelMessages: labelESMessages,
                staticLanguageMessages: "",
                isLoggedIn: false,
                isShowLoggedinfields: true,
                loginID: 0,
                userPermissions: [],
                roleId: 0,
                roleName: 0,
                currentYear: '2019',
            };
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            // self.staticLanguageMessages = self.allStaticLabelMessages;
            let lang = localStorage.getItem('api_lang');
            if (lang != null && lang != "") {
              if(lang == 'es') {
                self.staticLanguageMessages = self.spanishStaticLabelMessages;
              } else {
                self.staticLanguageMessages = self.englishStaticLabelMessages;
              }
            } else {
              self.staticLanguageMessages = self.englishStaticLabelMessages;
            }
            var appYear = localStorage.getItem('app_year');
            if (typeof (appYear) != "undefined") {
                if (appYear != null) {
                    self.currentYear = appYear;
                } else {
                    self.currentYear = moment().format('YYYY');
                }
            } else {
                self.currentYear = moment().format('YYYY');
            }
        },
        methods: {

        }
    };
</script>
